import PropTypes from "prop-types"
import React from "react"
import { Table } from "semantic-ui-react"

const CaseStatusDetails = ({ caseStatusFields }) => (
	<Table definition>
		<Table.Body>
			{caseStatusFields.map(({ label, value }, index) => (
				<Table.Row key={index}>
					<Table.Cell>{label}</Table.Cell>
					<Table.Cell>{value}</Table.Cell>
				</Table.Row>
			))}
		</Table.Body>
	</Table>
)

CaseStatusDetails.propTypes = {
	caseStatusFields: PropTypes.arrayOf(
		PropTypes.shape({ label: PropTypes.string, value: PropTypes.string })
	).isRequired
}

export { CaseStatusDetails }
export default CaseStatusDetails



// WEBPACK FOOTER //
// ./src/containers/case-statuses/components/CaseStatusDetails.js